import { useEffect, useRef } from 'react';

interface ITranslateElement {}

interface ITranslateElementOptions {
	autoDisplay?: boolean;
	defaultLanguage?: string;
	layout?: 'simple' | 'vertical' | 'horizontal';
}

declare global {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface Window {
		googleTranslateElementInit?: () => void;
		google?: {
			translate: {
				TranslateElement: {
					// eslint-disable-next-line no-new
					new (
						options: ITranslateElementOptions,
						elementId: string,
					): ITranslateElement;
					InlineLayout: {
						SIMPLE: 'simple';
						VERTICAL: 'vertical';
						HORIZONTAL: 'horizontal';
					};
				};
			};
		};
	}
}

export function useGoogleTranslate() {
	const scriptAdded = useRef(false); // Ensure script is only added once

	const addGoogleTranslateScript = () => {
		if (!scriptAdded.current) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = `//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit&hl=en`;
			script.async = true;
			document.body.appendChild(script);
			scriptAdded.current = true; // Mark the script as added
		}
	};

	const removePreviousTranslateElement = () => {
		const translateElement = document.getElementById(
			'google_translate_element',
		);
		if (translateElement) {
			translateElement.innerHTML = ''; // Remove the previously initialized dropdown
		}
	};

	useEffect(() => {
		// Initialise Google Translate
		window.googleTranslateElementInit = () => {
			if (window.google?.translate) {
				removePreviousTranslateElement();
				// eslint-disable-next-line no-new
				new window.google.translate.TranslateElement(
					{
						defaultLanguage: 'en',
						layout:
							window.google.translate.TranslateElement.InlineLayout.VERTICAL,
					},
					'google_translate_element',
				);
			} else {
				// eslint-disable-next-line no-console
				console.error('Google Translate API not loaded.');
			}
		};

		addGoogleTranslateScript();
	}, []);
}
